import { EVENT_CATEGORIES, EVENT_NAMES, HIT_TYPE } from '../../../beacon/const';

export const sessionResetBeacon = ({ payload }) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.BACKGROUND,
  eventName: EVENT_NAMES.SESSION_RESET,
  label: payload.oldSessionID,
  hitID: 1,
});
